// Cross-tab navigation for the BAC admin dashboard.
//
// Any screen inside AdminDashboard can open another tab, optionally handing it
// data to start from:
//
// AdminDashboard picks the redirect up from the router's location.state, selects
// the tab and passes `prefill` to that tab's component only. To make another tab
// redirectable: call navigateToAdminTab from the source screen, pass
// `prefill={prefill}` to the tab in AdminDashboard's PanelBody, and have the tab
// act on it (tabs that start with SearchCaseForm: `initialValues={prefill}`).

// Sidebar tab ids, as used by AdminDashboard's `selected` state.
export const ADMIN_TABS = {
  OVERVIEW: 1,
  REGISTER_NEW_CASE: 2,
  NOTICES: 3,
  VALUATION_OF_FEE: 4,
  ARBITRATORS: 5,
  DAILY_PROCEEDING: 6,
  CAUSE_LIST: 7,
  REPORTS: 8,
  MASTER: 9,
  BOOK_HEARING_ROOM: 10,
  SCRUTINY: 11,
  FINANCIAL_DASHBOARD: 12,
  GENERATE_VC_LINK: 13,
  EMAIL_DASHBOARD: 14,
  ORDER_DRAFTING: 15,
  MEETING_LINKS: 16,
  ADJOURNMENTS: 17,
  RESCHEDULE: 18,
};

export const ADMIN_TAB_REDIRECT_KEY = "adminTabRedirect";

// Open `tab` in the admin dashboard, handing it `prefill` (any data the tab
// understands; null to just switch tabs). The URL is left unchanged.
export const navigateToAdminTab = (history, tab, prefill = null) => {
  history.push({
    pathname: history.location.pathname,
    search: history.location.search,
    state: { [ADMIN_TAB_REDIRECT_KEY]: { tab, prefill } },
  });
};
